module.exports = require('./helpers/bundle-url').getBundleURL('37i63') + "logo.c51670a8.svg";